export var DEFAULT_STATE = {
  isLoading: false,
  isOpen: false,
  options: [],
  phoneInput: {
    value: ''
  },
  scenario: undefined,
  quickOptions: [],
  selectedPaymentId: undefined,
  submitButton: {},
  sumInput: {
    value: ''
  }
};